// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__24knf","buttons":"PendingPaymentAlert_buttons__2YSwC"};